import React, { useState, useEffect } from "react";
import Parser from "html-react-parser";
import {
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import DownloadIcon from "@mui/icons-material/Download";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import { DownloadBroadcastService } from "../../../services/NotificationService";
import { useLoading } from "../../../common/LoadingContext";
import { useNotificationContext } from "../../../common/NotificationContext";
import download from "downloadjs";
import RecordNotFoundNoNotification from "../../../common/RecordNotFoundNoNotification";


const BroadCast = (props) => {
  const {
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
  } = props;
  const [brodcastList, setBrodcastList] = useState([]);
  const [showMore, setShowMore] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();

  useEffect(async () => {
    await setBrodcastList(notificationRecords);
    return () => {
      setBrodcastList([]);
    };
  }, [
    brodcastList,
    notificationRecords,
    totalElements,
    handleChangePage,
    handleChangeRowsPerPage,
    rowsPerPage,
    page,
  ]);
  const handleChange = (id) => (_, isExpanded) => {
    setExpanded(isExpanded ? id : null);
    setShowMore(false);
  };

  // download broadcast
  const handleDownload = async (id) => {
    try {
      setLoading(true);
      const response = await DownloadBroadcastService(id);
      if (response) {
        const content = response.headers["content-type"];
        const [, filename] = response.headers['content-disposition'].split('filename=');
        const withoutFirstAndLast = filename.slice(1, -1);
        download(response.data, withoutFirstAndLast, content);
        showNotification("Success", "Succesfully Downloaded", "success");
      } else {
        showNotification("Error", response?.message ?? "Failed to download");
      }
    } catch (err) {
      console.log("err", err);

      showNotification("Error", "Failed to download");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {brodcastList && brodcastList.length > 0 ? (
        brodcastList
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <>
                <Accordion
                  sx={{
                    borderLeft: 7,
                    p: 0,
                    borderColor: "#003f93",
                    mb: 1,
                    textAlign: "left",
                  }}
                  key={row.id}
                  onChange={handleChange(row.id)}
                  expanded={expanded === row.id}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    onClick={() => setShowMore(false)}
                    className="broadcastDownloadWraper">
                    <Typography sx={{ textTransform: "capitalize" }}>
                      {row.title}{" "}
                    </Typography>
                    {row?.downloadable ? (
                      <span
                        className="broadcastDownload"
                        onClick={() => handleDownload(row.id)}>
                        <DownloadIcon />{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </AccordionSummary>
                  <AccordionDetails className="brodcastNotificationBlock">
                    <Typography>
                      {row?.content.startsWith('"')
                        ? showMore
                          ? Parser(JSON.parse(row?.content))
                          : Parser(JSON.parse(row?.content).substring(0, 122))
                        : showMore
                        ? row?.content
                        : row?.content.substring(0, 122)}
                        {row?.content.length > 122 ? (
                      <button
                        className="showMore"
                        onClick={() => setShowMore(!showMore)}>
                        {showMore ? "Show less" : "Show more"}{" "}
                        {showMore ? (
                          <KeyboardDoubleArrowLeftIcon />
                        ) : (
                          <KeyboardDoubleArrowRightIcon />
                        )}
                      </button>): ""}
                    </Typography>
                  </AccordionDetails>
                </Accordion>
              </>
            );
          })
      ) : (
        <RecordNotFoundNoNotification />
      )}
    </>
  );
};

export default BroadCast;
